interface IEarning {
  id: string;
  photo: string;
  driverName: string;
  rating: number;
  acceptance: number | null;
  count: number;
  gross: number;
  commission: number;
  errands: number;
  transferPrice: number;
  transferCost: number;
  parking: number;
  tips: number;
  other: number;
  payout: number;
}

const PeriodNames = {
  today: 'today',
  yesterday: 'yesterday',
  current_week: 'current_week',
  last_week: 'last_week',
  month: 'month',
  last_month: 'last_month',
} as const;

const PeriodNameEnum: { [K in keyof typeof PeriodNames]: K } = PeriodNames;

type TPeriodName = keyof typeof PeriodNameEnum;

export { PeriodNameEnum };
export type { IEarning, TPeriodName };
